import React, {useEffect, useState} from "react";
import {CircularProgress} from '@mui/material';
import Panel from "../layout/Panel";
import ProjectLoader from "../../classes/ProjectLoader";
import AnimatedLogo from "../icons/AnimatedLogo";
import "../../styles/ProjectLoadingDialog.scss";
import {ProjectLoadingEvents, ProjectLoadingStates} from "../../interfaces/enums";

type ProjectLoadingDialogProps = {
	staticWidth: boolean;
	loader: ProjectLoader;
	projectName: string;
};

const ProjectLoadingLabels: Record<ProjectLoadingStates, string> = {
	[ProjectLoadingStates.NONE]: "None",
	[ProjectLoadingStates.DOWNLOADING_PROJECT_FILE]: "Downloading Project File",
	[ProjectLoadingStates.DOWNLOADING_ASSETS]: "Downloading Assets",
	[ProjectLoadingStates.LOADING_PROJECT]: "Loading Project",
}

export default function ProjectLoadingDialog(props: ProjectLoadingDialogProps)
{
	const [state, setState] = useState<ProjectLoadingStates>(ProjectLoadingStates.NONE);
	const [stateProgress, setStateProgress] = useState<number>(0);

	useEffect(() =>
	{
		props.loader.on(ProjectLoadingEvents.STATE, setState);
		props.loader.on(ProjectLoadingEvents.STATE, (message) => console.log(message));
		props.loader.on(ProjectLoadingEvents.LOADING_PERCENT, setStateProgress);
	}, []);

	function calculatePercentage()
	{
		if(state === ProjectLoadingStates.LOADING_PROJECT) return 100; // we reach LOADING_PROJECT at 100% of the progress, so we can just return 100 here

		const numStates = Object.keys(ProjectLoadingLabels).length - 2; // Exclude NONE and LOADING_PROJECT, which don't report state progress

		const percentage = Math.round((Math.max(0, state - 1) / numStates + stateProgress / numStates) * 100);
		//console.log(`Calculate percentage:\n state: ${ProjectLoadingLabels[state]} (${state})\n stateProgress: ${stateProgress}\n (state / numStates) * stateProgress * 100: ${percentage}%`);
		return percentage;
	}

	function generateLabel()
	{
		switch(state)
		{
			case ProjectLoadingStates.NONE:
				return "Initializing";
			case ProjectLoadingStates.DOWNLOADING_PROJECT_FILE:
			case ProjectLoadingStates.DOWNLOADING_ASSETS:
				return `${ProjectLoadingLabels[state]}: ${Math.round(stateProgress * 100)}%`;
			case ProjectLoadingStates.LOADING_PROJECT:
				return "Almost there...";
		}
	}

	return (
		<Panel className={"projectLoadDialogRoot"}>
			<div className={"projectLabel"}>{props.projectName}</div>
			<div className={"progressWrapper"}>
				<AnimatedLogo infinite={calculatePercentage() < 100} />
				<CircularProgress 
					value={100} // this one if purely for background
					className={"loadingProgressBar"} 
					size={200}
					variant={"determinate"}
					sx={{ '& .MuiCircularProgress-circle': { color: '#303030' }}}
					thickness={1.5}
				/>
				<CircularProgress 
					value={state !== ProjectLoadingStates.LOADING_PROJECT ? calculatePercentage() : 100}
					className={"loadingProgressBar"}
					size={200}
					variant={"determinate"}
					sx={{ '& .MuiCircularProgress-circle': { color: '#EBA900' }}}
					thickness={1.5}
				/>
			</div>
			<div className={"loadProgressLabel"}>{generateLabel()}</div>
		</Panel>
	);
}

